import React, { Suspense, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useNavigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingSpinner from "./components/LoadingSpinner";
import Login from "./pages/Login";
import Sidebar from "./components/Sidebar";
import Subscribers from "./pages/Subscribers";
import Notifications from "./pages/Notifications";
import Users from "./pages/Users";
import Platforms from "./pages/Platforms";
import ContentManagement from "./pages/Settings";
import AdminManagement from "./pages/AdminManagement";
import ResetPassword from "./pages/reset-password";
import TwoFactorSettings from "./pages/TwoFactorSettings ";
const Dashboard = React.lazy(() => import("./pages/Dashboard"));

// ProtectedRoute component to guard authenticated routes
const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const token = localStorage.getItem("adminToken");
  const tokenTimestamp = localStorage.getItem("tokenTimestamp");
  const TOKEN_EXPIRY = 7 * 24 * 60 * 60 * 1000;

  useEffect(() => {
    if (!token || !tokenTimestamp) {
      localStorage.removeItem("adminToken");
      localStorage.removeItem("tokenTimestamp");
      localStorage.removeItem("adminData");
      navigate("/login", { replace: true });
      return;
    }

    const isTokenExpired =
      Date.now() - parseInt(tokenTimestamp, 10) > TOKEN_EXPIRY;
    if (isTokenExpired) {
      localStorage.removeItem("adminToken");
      localStorage.removeItem("tokenTimestamp");
      localStorage.removeItem("adminData");
      navigate("/login", { replace: true });
    }
  }, [token, tokenTimestamp, navigate]);

  const isTokenExpired =
    Date.now() - parseInt(tokenTimestamp, 10) > TOKEN_EXPIRY;
  return token && !isTokenExpired ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <Router>
      <ToastContainer />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <div className="flex min-h-screen">
                <Sidebar />
                <main className="flex-1 overflow-y-auto p-4">
                  <Suspense fallback={<LoadingSpinner />}>
                    <Routes>
                      <Route
                        path="/"
                        element={<Navigate to="/dashboard" replace />}
                      />
                      <Route path="/dashboard" element={<Dashboard />} />
                      <Route path="/Subscribers" element={<Subscribers />} />
                      <Route
                        path="/notifications"
                        element={<Notifications />}
                      />
                      <Route path="/users" element={<Users />} />
                      <Route path="/settings" element={<ContentManagement />} />
                      <Route path="/platforms" element={<Platforms />} />
                      <Route path="/TwoFactorSettings" element={<TwoFactorSettings />} />
                      <Route
                        path="/AdminManagement"
                        element={<AdminManagement />}
                      />
                    </Routes>
                  </Suspense>
                </main>
              </div>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
